import React from 'react'
import { useReduxSelector } from '../../hooks'
import { Preloader } from '../preloader'

interface PropType {
  component: React.FC
}

export const PrivateRoute: React.FC<PropType> = ({ component: Component }) => {
  const { loading, auth } = useReduxSelector((state) => state.auth)

  const { REACT_APP_PORTAL_URL: PORTAL } = process.env

  switch (true) {
    case loading:
      return <Preloader />
    case !auth:
      window.location.href = `${PORTAL}`
      return <Preloader />
    default:
      return <Component />
  }
}
